/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataStockManageListResVo } from './PageDataStockManageListResVo';
import {
    PageDataStockManageListResVoFromJSON,
    PageDataStockManageListResVoFromJSONTyped,
    PageDataStockManageListResVoToJSON,
    PageDataStockManageListResVoToJSONTyped,
} from './PageDataStockManageListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataStockManageListResVo
 */
export interface ResponsePageDataStockManageListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataStockManageListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataStockManageListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataStockManageListResVo}
     * @memberof ResponsePageDataStockManageListResVo
     */
    data?: PageDataStockManageListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataStockManageListResVo interface.
 */
export function instanceOfResponsePageDataStockManageListResVo(value: object): value is ResponsePageDataStockManageListResVo {
    return true;
}

export function ResponsePageDataStockManageListResVoFromJSON(json: any): ResponsePageDataStockManageListResVo {
    return ResponsePageDataStockManageListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataStockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataStockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataStockManageListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataStockManageListResVoToJSON(json: any): ResponsePageDataStockManageListResVo {
    return ResponsePageDataStockManageListResVoToJSONTyped(json, false);
}

export function ResponsePageDataStockManageListResVoToJSONTyped(value?: ResponsePageDataStockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataStockManageListResVoToJSON(value['data']),
    };
}

